import React from "react";
import { useNavigate } from "react-router-dom";
import DocumentManagement from "../../components/shared/DocumentManagement";
import { Target, ArrowLeftRight, DollarSign, Calendar, Eye, Download } from "lucide-react";

const IssuerDocumentManagement = () => {
    const navigate = useNavigate();

    const documentSections = [
        {
            id: "token-allocation",
            title: "Token Allocation Outcome Report",
            icon: Target,
            description: "Detailed report of token allocation outcomes",
            path: "/issuer/token-allocation-outcome"
        },
        {
            id: "token-mint-transfer",
            title: "Token Mint and Transfer Log",
            icon: ArrowLeftRight,
            description: "Complete log of token minting and transfer activities"
        },
        {
            id: "profit-distribution",
            title: "Profit Distribution/Coupon Payment Report",
            icon: DollarSign,
            description: "Reports on profit distributions and coupon payments"
        },
        {
            id: "redemption-payment",
            title: "Redemption Payment Report",
            icon: Calendar,
            description: "Track and manage redemption payment records"
        }
    ];

    return (
        <>
            {/* Document Reports Section */}
            <div className="bg-white shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-4">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">
                                Document Management
                            </h1>
                            <p className="text-sm text-gray-500">
                                Manage your bond-related documents and reports
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Document Reports</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {documentSections.filter(section => section.id === 'token-allocation').map((section) => {
                            const Icon = section.icon;
                            return (
                                <div
                                    key={section.id}
                                    className="bg-white border-2 border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-all"
                                    onClick={() => section.path && navigate(section.path)}
                                >
                                    <div className="flex items-start justify-between mb-3">
                                        <Icon className="w-6 h-6 text-gray-600" />
                                        {section.path ? (
                                            <div className="flex gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-white/50"
                                                    title="View"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate(section.path);
                                                    }}
                                                >
                                                    <Eye className="w-4 h-4 text-gray-600" />
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex gap-2">
                                                <button className="p-1 rounded hover:bg-white/50" title="View">
                                                    <Eye className="w-4 h-4 text-gray-600" />
                                                </button>
                                                <button className="p-1 rounded hover:bg-white/50" title="Download">
                                                    <Download className="w-4 h-4 text-gray-600" />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <h3 className="text-sm font-semibold text-gray-900 mb-1">{section.title}</h3>
                                    <p className="text-xs text-gray-700">{section.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Bond Documents Section */}
            <DocumentManagement role="issuer" />
        </>
    );
};

export default IssuerDocumentManagement;
